(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-cb-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-sm-cb]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const cta = root.querySelector('[data-cb-cta]');
      const price = root.querySelector('[data-cb-price]');
      const compare = root.querySelector('[data-cb-compare]');
      const apply = (card) => {
        root.querySelectorAll('[data-cb-offer]').forEach((el) => el.classList.toggle('is-on', el === card));
        if (cta && card.dataset.url) cta.href = card.dataset.url;
        if (cta && card.dataset.cta) cta.textContent = card.dataset.cta;
        if (price && card.dataset.total) price.textContent = card.dataset.total;
        if (compare) { compare.textContent = card.dataset.compare || ''; compare.hidden = !card.dataset.compare; }
      };
      root.addEventListener('click', (event) => {
        const card = event.target.closest('[data-cb-offer]');
        if (card) apply(card);
      });
      const on = root.querySelector('[data-cb-offer].is-on') || root.querySelector('[data-cb-offer]');
      if (on) apply(on);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-material-details"] && !Shopify.designMode) return;
  try {
    
  function initializeMaterialLoops(root = document) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('video[data-sm-motion-loop]:not([data-sm-motion-ready])').forEach((video) => {
      video.dataset.smMotionReady = 'true';
      if (reduceMotion.matches || !('IntersectionObserver' in window)) return;
      let viewerPaused = false;
      video.addEventListener('pause', () => {
        if (!video.dataset.smOutsideViewport) viewerPaused = true;
      });
      video.addEventListener('play', () => { viewerPaused = false; });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            delete video.dataset.smOutsideViewport;
            if (!viewerPaused && !reduceMotion.matches) video.play().catch(() => {});
          } else {
            video.dataset.smOutsideViewport = 'true';
            video.pause();
          }
        });
      }, { threshold: 0.25 });
      observer.observe(video);
    });
  }
  initializeMaterialLoops();
  document.addEventListener('shopify:section:load', (event) => initializeMaterialLoops(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-ugc-player"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rows = document.querySelectorAll('[data-sm-ugc-row]');
    rows.forEach((row) => {
      if (row.dataset.ready === 'true') return;
      row.dataset.ready = 'true';

      const cards = [...row.querySelectorAll('.sm-ugc__card')];
      const playAllMuted = () => {
        cards.forEach((card) => {
          const video = card.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.play().catch(() => {});
        });
      };

      row.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sm-ugc-play]');
        if (!button) return;
        const card = button.closest('.sm-ugc__card');
        const video = card.querySelector('video');
        const wasOn = card.classList.contains('is-on');
        cards.forEach((other) => {
          other.classList.remove('is-on');
          const otherVideo = other.querySelector('video');
          if (otherVideo) otherVideo.muted = true;
        });
        if (!wasOn) {
          card.classList.add('is-on');
          video.muted = false;
          video.play().catch(() => {});
        }
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) playAllMuted();
          });
        }, { threshold: 0.2 });
        observer.observe(row);
      } else {
        playAllMuted();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
